export default __webpack_public_path__ + "static/media/icon-taks-exam.f4553111.svg";